// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .required {
  color: #ffcb37;
}
:host tr.header {
  background-color: var(--ion-color-primary);
  width: 100%;
  text-align: center;
  border: 0px;
}
:host .danger {
  margin-top: 0;
  margin-bottom: 0;
  color: red;
}
:host .submit-button {
  margin-top: 20px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
